import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcademyCourtsService {

  constructor(private http:HttpClient) { }

  updateCourt(id,data) {
    return this.http.put(`${environment.apiUrl}academy-court/${id}`,data);
  }

  getCourts(query:string) {
    return this.http.get(`${environment.apiUrl}academy-court${query}`);
  }

  getCourtById(id:string) {
    return this.http.get(`${environment.apiUrl}academy-court/${id}`);
  }

  getCourtSlotById(query:string) {
    return this.http.get(`${environment.apiUrl}academy-court/slots?${query}`);
  }

  addCourtSetAvailability(data) {
    return this.http.post(`${environment.apiUrl}setavailability`,data);
  }

  updateCourtSlotSetAvailability(id,data) {
    return this.http.put(`${environment.apiUrl}setavailability/slots/${id}`,data);
  }

  updateCourtSlotByBlockOrUnBlocKAvailability(setAvailabilityId,data) {
    return this.http.put(`${environment.apiUrl}setavailability/update/${setAvailabilityId}`,data);
  }

  getCourtBookingDetails(query:string) {
    return this.http.get(`${environment.apiUrl}courtbooking${query}`);
  }

  updateCourtBookingDetails(id,data) {
    return this.http.put(`${environment.apiUrl}courtbooking/${id}`,data);
  }
  
}